import React, { Component } from 'react';
import { getCurrentUser } from "../../util/api";
import { API_BASE_URL } from "../../constatns";

class Profile extends Component {
	constructor(props) {
		super(props);
		this.state = {
			authenticated: false,
			currentUser: null
		}

		this.loadCurrentlyLoggedInUser = this.loadCurrentlyLoggedInUser.bind(this);
		this.upload = this.upload.bind(this);
	}

	loadCurrentlyLoggedInUser() {
		getCurrentUser().then(response => {
			this.setState({
				currentUser: response,
				authenticated: true
			});

			console.log(response)
		}).catch(error => {
		});
	}

	componentDidMount() {
		this.loadCurrentlyLoggedInUser();
	}

	upload(event) {
		const formData = new FormData();
		formData.append('imgFile', event.target.files[0]);
		formData.append('id', this.state.currentUser.id);

		fetch(API_BASE_URL+'/file/profile', {
			method: 'POST',
			body: formData
		}).then(e => e.json()).then(e => {
			let user = this.state.currentUser;
			user.imageUrl= API_BASE_URL+'/file/show?f='+e.path;
			this.setState({
				currentUser: user
			});
		});

	}

	render() {
		return (
			<div className="profile-container">
				<input type="file" name="imgFile" onChange={this.upload} />
				<div className="container">
					{this.state.currentUser ?
						<div className="profile-info">
							<div className="profile-avatar">
								{
									this.state.currentUser.imageUrl ? (
										<img src={this.state.currentUser.imageUrl} alt={this.state.currentUser.name}/>
									) : (
										<div className="text-avatar">
											<span>{this.state.currentUser.name && this.state.currentUser.name[0]}</span>
										</div>
									)
								}
							</div>
							<div className="profile-name">
								<h2>{this.state.currentUser.name}</h2>
								<p className="profile-email">{this.state.currentUser.email}</p>
							</div>
						</div>
					: ''}
				</div>
			</div>
		);
	}
}

export default Profile
